<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0,0,256,256"
  >
    <g transform="translate(-66.56,-66.56) scale(1.52,1.52)">
      <g
        fill="none"
        fill-rule="nonzero"
        stroke="none"
        stroke-width="1"
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke-miterlimit="10"
        stroke-dasharray=""
        stroke-dashoffset="0"
        font-family="none"
        font-weight="none"
        font-size="none"
        text-anchor="none"
        style="mix-blend-mode: normal"
      >
        <g transform="scale(5.33333,5.33333)">
          <path
            d="M24,4c-11.04569,0 -20,8.95431 -20,20c0,11.04569 8.95431,20 20,20c11.04569,0 20,-8.95431 20,-20c0,-11.04569 -8.95431,-20 -20,-20z"
            fill-opacity="0.01176"
            fill="#ede7f6"
          ></path>
          <path d="M28,31c0,0 0,4 -4,4c-4,0 -4,-4 -4,-4" fill="#ff9800"></path>
          <path
            d="M24,44c4.482,0 8.605,-1.492 11.939,-3.982c-0.619,-7.566 -8.189,-9.018 -8.189,-9.018l-3.75,0.77l-3.75,-0.77c0,0 -7.572,1.424 -8.19,9.018c3.335,2.49 7.458,3.982 11.94,3.982z"
            fill="#673ab7"
          ></path>
          <path
            d="M24,37c3.059,0 5.578,-2.292 5.948,-5.25c-0.884,-0.398 -1.603,-0.607 -1.954,-0.693c-0.031,2.181 -1.805,3.943 -3.994,3.943c-2.19,0 -3.964,-1.762 -3.994,-3.945c-0.353,0.086 -1.071,0.293 -1.955,0.688c0.366,2.962 2.887,5.257 5.949,5.257z"
            fill="#311b92"
          ></path>
          <path
            d="M32,22.5c0,0.828 -0.672,1.5 -1.5,1.5c-0.829,0 -1.5,-0.672 -1.5,-1.5c0,-0.828 0.671,-1.5 1.5,-1.5c0.828,0 1.5,0.672 1.5,1.5M19,22.5c0,-0.828 -0.672,-1.5 -1.5,-1.5c-0.828,0 -1.5,0.672 -1.5,1.5c0,0.828 0.672,1.5 1.5,1.5c0.828,0 1.5,-0.672 1.5,-1.5M28,31v-4h-8v4c0,0 0,4 4,4c4,0 4,-4 4,-4z"
            fill="#63342b"
          ></path>
          <path
            d="M31,18.68c0,-5.879 -14,-3.827 -14,0v4.391c0,3.824 3.133,6.93 7,6.93c3.866,0 7,-3.105 7,-6.93z"
            fill="#8e5042"
          ></path>
          <path
            d="M24,11c-4.86,0 -8,4.313 -8,8.172v1.828l2,2v-4l9.2,-3l2.8,3v4l2,-2v-0.809c0,-3.218 -0.831,-6.803 -4.8,-7.592l-0.801,-1.599z"
            fill="#292d30"
          ></path>
          <path
            d="M26,22c0,-0.551 0.448,-1 1,-1c0.552,0 1,0.449 1,1c0,0.551 -0.448,1 -1,1c-0.552,0 -1,-0.449 -1,-1M20,22c0,0.551 0.448,1 1,1c0.552,0 1,-0.449 1,-1c0,-0.551 -0.448,-1 -1,-1c-0.552,0 -1,0.449 -1,1"
            fill="#212121"
          ></path>
        </g>
      </g>
    </g>
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "UserMaleIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
